/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Diaby's Portfolio",
  description:
    "Passionné par le football, j'apprécie le dynamisme et l'esprit d'équipe que ce sport apporte. De nature curieuse, j'aime constamment apprendre de nouvelles choses et relever des défis qui me permettent de grandir tant sur le plan personnel que professionnel.",
  og: {
    title: "Diaby DRAME Portfolio",
    type: "website",
    url: "https://diaby-drame.github.io",
  },
};

//Home Page
const greeting = {
  title: "Diaby DRAME",
  logo_name: "Diaby DRAME",
  profile_image_path: "Moi.png",
  subTitle: "Je suis titulaire  de la licence Mathématiques et du Master 2 en ingénierie statistique et data science de Sorbonne Université (ex UPMC). Mon parcours académique s'est enrichi d'une alternance et d'un stage, où j'ai pu appliquer mes compétences en analyse de données dans des environnements professionnels réels. Passionné par le football, j'apprécie le dynamisme et l'esprit d'équipe que ce sport apporte. De nature curieuse, j'aime constamment apprendre de nouvelles choses et relever des défis qui me permettent de grandir tant sur le plan personnel que professionnel.",
  resumeLink: "",
  portfolio_repository: "https://diaby-drame.github.io",
  githubProfile: "https://github.com/diaby-drame",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/diaby-drame",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/diaby-dram%C3%A9-255136201/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:kissimadrame72@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
];

const skills = {
  data: [
    {
      title: "Data Science & IA",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Collecter et prétraiter les données",
        "⚡ Développer des modèles statistiques et des algorithmes d'apprentissage automatique",
        "⚡ Analyser les données pour en extraire de la valeur",
        "⚡ Communiquer les résultats via des visualisations et des rapports",
        "⚡ Collaborer avec des équipes pluridisciplinaires",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          imageSrc: "Python-logo.png",
        },
        {
          skillName: "Git",
          imageSrc: "git_logo.png",
        },
        {
          skillName: "Scikitlearn",
          imageSrc: "scikit_learn_logo.png",
        },
        // {
        //   skillName: "darts",
        //   imageSrc: "darts-logo.png",
        // },
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "PyTorch",
          imageSrc: "pytorch_logo.png",
        },
        // {
        //   skillName: "Hugging Face",
        //   imageSrc: "hugging_face_logo.png",
        // },
        {
          skillName: "OpenAI",
          imageSrc: "OpenAI_Logo.png",
        },
        {
          skillName: "Streamlit",
          imageSrc: "Streamlit-logo.png",
        },
        {
          skillName: "AWS",
          imageSrc: "AWS_logo.png",
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
        },
      ],
    },
    {
      title: "Data Analysis",
      fileName: "DataAnalystImg",
      skills: [
        "⚡ Créer des outils de visualisation pour l'analyse des données et la prise de décision basée sur les données",
        "⚡ Gestion de base de données SQL pour le stockage et la récupération des données",
        "⚡ Créer des rapports et des tableaux de bord",
        "⚡ Effectuer des analyses statistiques"
      ],
      softwareSkills: [
        {
          skillName: "PostGreSQL",
          imageSrc: "LogoPostgreSql.png",
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "logos:mysql",
        },
        // {
        //   skillName: "Looker",
        //   imageSrc: "Looker.png",
        // },
        {
          skillName: "Tableau",
          imageSrc: "Tableau_sofware.png",
        },
        {
          skillName: "Power BI",
          imageSrc: "power_bi.png",
        },
        {
          skillName: "Python",
          imageSrc: "Python-logo.png",
        },
        // {
        //   skillName: "Streamlit",
        //   imageSrc: "Streamlit-logo.png",
        // },
      ],
    },
    {
      title: "Data Engineering",
      fileName: "DataEngineerImg",
      skills: [
        "⚡ Concevoir et maintenir des pipelines de données",
        "⚡ Assurer la qualité et la cohérence des données",
        "⚡ Développer des solutions d'entreposage de données",
        // "⚡ Collaborer avec les data scientists et les analystes",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Apache Airflow",
          fontAwesomeClassname: "logos:airflow",
        },
        // {
        //   skillName: "Google Big Querry",
        //   imageSrc: "google_big_querry.png",
        // },
        {
          skillName: "Python",
          imageSrc: "Python-logo.png",
        },
        {
          skillName: "Git",
          imageSrc: "git_logo.png",
        },
        {
          skillName: "Spark",
          fontAwesomeClassname: "logos:apache-spark",
          style: {
            backgroundColor:"transparent",
            // color: "#FF9900",

        },
        },
        // {
        //   skillName: "Snowflake",
        //   fontAwesomeClassname: "logos:snowflake",
        //   style: {
        //     backgroundColor: "#transparent",
        //   },
        // },
      ],
    },
  ],
};

// Education Page
// const competitiveSites = {
//   competitiveSites: [
//     {
//       siteName: "Kaggle",
//       iconifyClassname: "simple-icons:kaggle",
//       style: {
//         color: "#20BEFF",
//       },
//       profileLink: "https://www.kaggle.com/laymanbrother",
//     },
//   ],
// };

const degrees = {
  degrees: [
    {
      title: "Institut de Statistique de Sorbonne Université (ISUP)",
      subtitle: "Master 2 Ingénierie Statistique et Data Science (ISDS)",
      logo_path: "isup.png",
      alt_name: "ISUP",
      duration: "2022 - 2023",
      descriptions: [
        "⚡ L'ISUP est un département de formation de Sorbonne Université (ex UPMC) avec comme vocation de développer des parcours de haut niveau dans le domaine de la statistique et de la science des données",
        "⚡ Parcours de haut niveau qui prépare aux carrières de Statisticien et Data Scientist",
        "⚡ Acquisition d'une spécialisation recherchée en statistiques et une solide formation en informatique, devenant ainsi un professionnel reconnu dans les domaines où la statistique et la data science jouent un rôle crucial",
      ],
      website_link: "https://isup.sorbonne-universite.fr/",
    },
    {
      title: "Sorbonne Université",
      subtitle: "Master 1 Mathématiques et applications",
      logo_path: "logo_SU.png",
      alt_name: "Sorbonne Université",
      duration: "2021 - 2022",
      descriptions: [
        "⚡ Sorbonne Université (ex UPMC) se classe parmi les meilleures universités du monde",
        "⚡ Revoir les éléments fondamentaux nécessaires pour poursuivre un cursus mathématique de haut niveau",
        "⚡ Exploration des différentes orientations via des UE spécifiques et préparation à la sélection de l'une des huit spécialités offertes en master 2",
      ],
      website_link: "https://sciences.sorbonne-universite.fr/",
    },
    {
      title: "Sorbonne Université",
      subtitle: "Licence Mathématiques",
      logo_path: "logo_SU.png",
      alt_name: "Sorbonne Université",
      duration: "2018 - 2021",
      descriptions: [
        "⚡ Sorbonne Université (ex UPMC) se classe parmi les meilleures universités du monde",
        "⚡ La formation offre un socle solide de connaissances et compétences en mathématiques",
      ],
      website_link: "https://sciences.sorbonne-universite.fr/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Power BI : De débutant à expérimenté par la pratique",
      subtitle: "- Udemy",
      fontAwesomeClassname: "logos:udemy",
      logo_path: "udemy_logo.png",
      certificate_link: "https://www.udemy.com/certificate/UC-912794e1-18fb-4f11-b238-b890f503afc0/",
      alt_name: "Power BI formation",
      color_code: "#ffffff",
    },
    {
      title: "Bash/Linux : Programme Data Upskilling",
      subtitle: " Benjamin Dubreu",
      fontAwesomeClassname: "logos:upskilling",
      logo_path: "upskilling.png",
      certificate_link: "https://github.com/diaby-drame/Programme-Data-Upskilling/blob/main/Linux/ProgrammeDataUpskillingBashLinux.pdf",
      alt_name: "PDU",
      color_code: "#ffffff",
  },
  {
    title: "SQL : Programme Data Upskilling",
    subtitle: " Benjamin Dubreu",
    fontAwesomeClassname: "logos:upskilling",
    logo_path: "upskilling.png",
    certificate_link: "https://github.com/diaby-drame/Programme-Data-Upskilling/blob/main/SQL/ProgrammeDataUpskillingSQL.pdf",
    alt_name: "PDU",
    color_code: "#ffffff",
  },
  {
    title: "GIT : Programme Data Upskilling",
    subtitle: " Benjamin Dubreu",
    fontAwesomeClassname: "logos:upskilling",
    logo_path: "upskilling.png",
    certificate_link: "https://github.com/diaby-drame/Programme-Data-Upskilling/blob/main/Git/ProgrammeDataUpskillingGIT.pdf",
    alt_name: "PDU",
    color_code: "#ffffff",
  },
  {
    title: "Python : Programme Data Upskilling",
    subtitle: " Benjamin Dubreu",
    fontAwesomeClassname: "logos:upskilling",
    logo_path: "upskilling.png",
    certificate_link: "https://github.com/diaby-drame/Programme-Data-Upskilling/blob/main/Python/ProgrammeDataUpskillingPython.pdf",
    alt_name: "PDU",
    color_code: "#ffffff",
  },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Professionnel, Etudiant",
  description:
    "De mes premiers emplois d'étudiant à ma fonction actuelle dans la Data, mon parcours professionnel reflète une diversité d'expériences qui ont influencé ma démarche face aux problèmes.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Professionnel",
      work: true,
      experiences: [
        {
          title: "Data Scientist",
          company: "QuickSign",
          company_url: "https://www.quicksign.com/fr/",
          logo_path: "quicksign_.png",
          duration: "Janvier 2024 - Octobre 2024",
          location: "Paris",
          description: [
            "•  QuickSign fait de l’onboarding digital avec une plateforme pour souscrire en ligne à tout type de contrat bancaire et d’assurance.\n",
            "⚡ Créer des templates pour la reconnaissance de documents structurés\n",
            "⚡ Utiliser le modèle d’OCR pour lire les templates\n",
            "⚡ Utiliser des techniques de prétraitement/post-traitement pour améliorer la performance du modèle\n",
            "⚡ Recherche d’hyperparamètres pour l’optimisation\n",
            "⚡ Intégrer du template et modèle amélioré dans le service web\n",
            "⚡ Mettre en place un service de localisation automatique  des 4 coins d'un document\n"
          ],
          color: "#000000",
        },
        {
          title: "Data Scientist/Analyst Alternant",
          company: "Fotonower",
          company_url: "https://www.fotonower.com/",
          logo_path: "fotonower_.png",
          duration: "Novembre 2022 - Août 2023",
          location: "Paris",
          description: [
          "•  Fotonower, start-up fondée en 2014, excelle dans l'analyse et la reconnaissance d'images via le deep learning et l'IA.\n",
          "⚡ Améliorer la caractérisation automatique des déchets en utilisant le Mask R-CNN et la segmentation sémantique\n",
          "⚡ Élaboration d'un modèle de classi cation multi-matière : Random Forest, Gradient Boosting et réseaux de neurones CNN\n",
          "⚡Utiliser les chaînes de Markov pour améliorer l'identi cation des matières majoritaires\n",
          "⚡Etudes/Analyses statistiques sur les différents résultats\n",
          "⚡Implémentation des codes python",
        ],
          color: "#000000",
        },
      ],
    },
    {
      title: "Etudiant",
      work:true,
      experiences: [
        {
          title: "Employé polyvalent",
          company: "KFC",
          company_url: "https://www.kfc.fr/",
          logo_path: "kfc.png",
          duration: "Juin 2020 - Septembre 2022",
          location: "Servon",
          description:
          "⚡Préparation des commandes, accueil, entretien du restaurant, véri cation DLC",
          color: "#000000",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projets",
  description:
    "Mes projets utilisent une grande variété d’outils technologiques les plus récents. Depuis la phase de prétraitement des données, jusqu'à la modélisation et au déploiement, j'apprécie la création de projets Data Science.",
  avatar_image_path: "projects_image.svg",
};

const personalprojects = {
  data: [
    {
      id: "sql-srs",
      name: "SQL-SRS",
      createdAt: "2024-01",
      description: "Une application Streamlit pour réviser le langage SQL.",
      url: "https://github.com/diaby-drame/sql_srs",
      logo: [
        //
      ],
    },
    {
      id: "sensor-api",
      name: "Sensor API",
      createdAt: "2024-02",
      description: "Créer et requêter une API avec FastApi",
      url: "https://github.com/diaby-drame/sensor_api",
      logo: [
        //
      ],
    },
    {
      id: "heart-disease",
      name: "Heart Disease",
      createdAt: "2024-07",
      description: "",
      url: "https://github.com/diaby-drame/Heart-Disease",
      logo: [
        //
      ],
    },
    {
      id: "sports-data",
      name: "Sports Data",
      createdAt: "2024-11",
      description: "Scrapper le match Chelsea vs Newcastle et sauvegarder les données sur les événements du match dans une table supabase.",
      url: "https://github.com/diaby-drame/Sports-Data",
      logo: [
        //
      ],
    },
  ],
};

const publicationsHeader = {
  title: "Projets scolaires",
  description: "Quelques projets que j'ai réalisés tout au long de mon parcours scolaire.",
};

const publications = {
  data: [
    {
      id: "machine-learning",
      name: "Machine learning",
      createdAt: "2022-12",
      description: " Utiliser des modèles d'apprentissage supervisé/non supervisé pour prédire les types de véhicules en fonction de plusieurs caractéristiques issues de leurs silhouettes ",
      url: "https://github.com/diaby-drame/Projets-scolaires/tree/main/Master2/Apprentissage_Statistique",
    },
    {
      id: "séries-temporelles",
      name: "Séries temporelles",
      createdAt: "2023-01",
      description: " Prédire les futurs emprunts de vélos du jeu de données London bike",
      url: "https://github.com/diaby-drame/Projets-scolaires/tree/main/Master2/Prevision_series_temporelles",
    },
    {
      id: "réseaux-de-neuronnes",
      name: "Réseaux neuronaux",
      createdAt: "2023-01",
      description: "Mettre en place le réseau de neurones symétrique de Hop eld en propagation synchrone et asynchrone",
      url: "https://github.com/diaby-drame/Projets-scolaires/tree/main/Master2/Reseaux_neuronaux",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contacts",
    profile_image_path: "Moi.png",
    description:
      "Je suis là si vous avez besoin de discuter d'une nouvelle opportunité ou de mes projets."
  },
  // blogSection: {
  //   title: "Blogs",
  //   subtitle:
  //     "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
  //   link: "https://blogs.ashutoshhathidara.com/",
  //   avatar_image_path: "blogs_image.svg",
  // },
  // addressSection: {
  //   title: "Address",
  //   subtitle: "Saratoga Ave, San Jose, CA, USA 95129",
  //   locality: "San Jose",
  //   country: "USA",
  //   region: "California",
  //   postalCode: "95129",
  //   streetAddress: "Saratoga Avenue",
  //   avatar_image_path: "address_image.svg",
  //   location_map_link: "https://maps.app.goo.gl/NvYZqa34Wye4tpS17",
  // },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  personalprojects,
  publicationsHeader,
  publications,
  contactPageData,
};
